import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import MyProject from "../pages/Project/MyProject";
import { connect, useSelector, useDispatch } from "react-redux";
import ProjectDetailSection from "../pages/Project/ProjectChildComponent/ProjectDetail";
import { withRouter, useLocation } from "react-router-dom";
import {
  RIGHT_BOTTOM,
  RIGHT_TOP,
  TOGGLE_WORK_AREA,
  OPEN_CHATS,
  OPEN_BOTTOM_CHATS,
  OPEN_PROJECTS,
  OPEN_BOTTOM_PROJECTS,
  GROUPS,
  PROJECTS,
  ALL_BADGE_COUNT,
  GROUP_CHATS,
  UPDATE_PROJECT_ACTION_FIRE,
  TOGGLE_CHAT,
  TOGGLE_PROJECT,
  TOGGLE_LATEST_MSG,
  SET_OVERSIGHT_ROOM,
} from "../store";
import Chat from "../pages/Chat/chat";
import Conversation from "../pages/Chat/Coversation";
import { pure } from "recompose";
import { Badge } from "react-bootstrap";

import { KJUUP_COLORS } from "../helper/constants";
import { ReactComponent as ChatActived } from '../Icons/One-to-chat-activated-deactived.svg';
import { ReactComponent as ChatDeactived } from '../Icons/One-to-chat-activated.svg';
import SearchBar from "./SearchBar";
import OversightRoomDetail from "../pages/Project/OversightRoomDetail";
import "./RightBar.css";






function RightBar(props) {
  const dispatch = useDispatch();
  const windowWidth = window.innerWidth - 960;
  const { drawerOpen } = useSelector((state) => state);
  const { unSeenAllCount } = useSelector((state) => state);
  const openChatToggle = useSelector(state => state.openChatToggle);
  const openProjectToggle = useSelector(state => state.openProjectToggle);
  const openLatestMsgToggle = useSelector(state => state.openLatestMsgToggle);
  const [bottomAreaWidth, setBottomAreaWidth] = useState(windowWidth);
  const [projectsViewArea, setProjectsViewArea] = useState(windowWidth);
  const [colorC, setColorC] = useState(KJUUP_COLORS.base_color)
  const _serColor = useCallback((e) => setColorC(e), [])
  const inActivity = useSelector(e => e.inActivity)
  const activeSideBar = useSelector(e => e.activeSideBar)
  const isLatestMessagesSidebar = activeSideBar === 'LatestMessages';
  const isDesktop = useSelector(e => e.isDeskTopResolution)
  const activePinnedRoomId = useSelector(e => e.activePinnedRoomId)
  const hideRoomList = !!activePinnedRoomId
  const roomsAliveRef = useRef(false);
  if (props.rightTop === "project1") roomsAliveRef.current = true;
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth)
  const deeplinkData = useSelector(e => e.deeplinkData)
  const deeplinkLoading = useSelector(e => e.deeplinkLoading)
  const chatFullscreen = useSelector(e => e.chatFullscreen)
  const location = useLocation();
  
  // Check if we're opening a chat from a foreign profile (via URL param or deeplink)
  // URL param ?fullscreen=true is the most reliable indicator
  const urlParams = new URLSearchParams(location.search);
  const isFullscreenMode = urlParams.get('fullscreen') === 'true';
  
  // Hide the chat list and expand the open conversation when a chat is opened
  // from a profile or deeplink: fullscreen URL param, a chat deeplink, or
  // chatFullscreen (set when navigating to a direct message from search).
  const isOpeningFromProfile = isFullscreenMode || !!(deeplinkData && deeplinkData.chatGroupId) || deeplinkLoading || chatFullscreen;
  const roomsExclusive = viewportWidth <= 1380;
  // Company-admin oversight room (Räume > Oversight), shown in place of a regular room.
  const oversightRoom = useSelector(e => e.oversightRoom)
  const hasOpenProjects = (props.openProjects?.length || 0) > 0;
  const roomOpen = hasOpenProjects || !!oversightRoom;

  useEffect(() => {
    if (hasOpenProjects && oversightRoom) dispatch({ type: SET_OVERSIGHT_ROOM, payload: null });
  }, [hasOpenProjects, oversightRoom, dispatch]);

  // Capture deeplink scroll target for 1-on-1 chats before deeplinkData is cleared
  const [chatScrollTarget, setChatScrollTarget] = useState(null);
  useEffect(() => {
    if (deeplinkData?.chatGroupId && deeplinkData?.messageId && !deeplinkData?.roomId) {
      setChatScrollTarget({
        chatGroupId: deeplinkData.chatGroupId,
        messageId: deeplinkData.messageId,
        page_no: deeplinkData.page_no,
      });
    }
  }, [deeplinkData?.chatGroupId, deeplinkData?.messageId, deeplinkData?.roomId]);

  useEffect(() => {
    props.updateProjectAction(true);
  }, [])

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [])

  useEffect(() => {
    const cntProject = props?.openProjects?.length || 0;
    if (cntProject) {
      let newWidth = drawerOpen ? cntProject * 400 + windowWidth : "100%";
      setProjectsViewArea(newWidth);
    }
  }, [props.openProjects, drawerOpen]);

  useEffect(() => {
    const cntProject = props.openChats?.length || 0;
    if (cntProject) {
      let newWidth = drawerOpen ? cntProject * 400 + windowWidth : "100%";
      setProjectsViewArea(newWidth);
    }
  }, [props.openChats, drawerOpen]);

  useEffect(() => {
    const cntProject = props?.openBottomChats?.length || 0;
    if (cntProject) {
      let newWidth = drawerOpen ? cntProject * 400 + windowWidth : "100%";
      setBottomAreaWidth(newWidth);
    }
  }, [props.openBottomChats, drawerOpen]);

  useEffect(() => {
    const projects = props?.openBottomProjects || [];
    const cntProject = projects.length;
    if (cntProject) {
      let newWidth = drawerOpen ? cntProject * 400 + windowWidth : "100%";
      setBottomAreaWidth(newWidth);
    }
  }, [props.openBottomProjects, drawerOpen]);

  useEffect(() => {
    if (document.querySelector(".project-items")) {
      const slider = document.querySelector(".project-items");
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active-chat");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active-chat");
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active-chat");
      });
      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
      });
    }
  }, [inActivity]);

  const toggleWorkArea = () => {
    props.updateOpenChats([]);
    props.updateOpenBottomChats([]);
    props.updateOpenProjectsList([]);
    props.updateBottomOpenProjects([]);
    props.updateToggleWorkArea(!props.workArea);
    const updateGroups = props.groups.map((g) => {
      g.isOpened = false;
      return g;
    });
    props.updateGroups(updateGroups);
    const updateProjects = props.projects.map((g) => {
      g.isOpened = false;
      return g;
    });
    props.updateProjects(updateProjects);
  };

  // On narrow screens (<861px): keep the rooms list visible by default, but hide
  // it when a project is opened. Do not do that on Nachrichten — the messages
  // page uses the same flag to slide its own list away, and a room left open
  // from Räume would cover it with an empty pane.
  useEffect(() => {
    if (!isDesktop && location.pathname !== "/messages") {
      dispatch({ type: TOGGLE_PROJECT, payload: roomOpen });
      if (roomOpen && openLatestMsgToggle) {
        dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
      }
    }
  }, [isDesktop, location.pathname, roomOpen, openLatestMsgToggle, dispatch]);

  // Hide RightBar completely when on ToDo view, the Cockpit start page, the
  // company settings (with the Admin-Panel sections) or ForeignCompanyDetails
  // to allow full-screen width
  const isForeignCompanyDetails = location.pathname.startsWith('/foreign-company-details/');
  const isCockpitPage = location.pathname === '/' || location.pathname === '/cockpit';
  const isCompanyAdminPage =
    location.pathname.startsWith('/company-admin/') ||
    location.pathname.startsWith('/kjuup-io/') ||
    location.pathname.startsWith('/company-setting/');
  // /todo is only a redirect to the cockpit now (tasks live inside projects);
  // hide the bar for that one frame as well.
  const isTodoPage = location.pathname === '/todo';
  const hideRightBar = isTodoPage || isCockpitPage || isCompanyAdminPage || isForeignCompanyDetails;

  // These pages keep the RightBar reserving half the screen so they render at a
  // consistent max width, regardless of where they were navigated from (e.g.
  // article title vs. company link on profile). The article create/edit pages
  // (including their preview state) share the same layout as company details.
  // Below 1600px the empty half-screen spacer is skipped for company details so
  // the page can use the full width next to the sidebar.
  const COMPANY_FULL_WIDTH_BELOW = 1600;
  const constrainedWidthPaths = [
    '/company-details/',
    '/create-company-article',
    '/add-company-article/',
    '/edit-company-article/',
  ];
  const isCompanyDetailsPage = location.pathname.startsWith('/company-details/');
  const isEditCompanyPage = location.pathname.startsWith('/edit-company/');
  const isCompanySettingPage = location.pathname.startsWith('/company-setting/');
  const isCompanyFollowersPage = location.pathname.startsWith('/company-followers/');
  const isAddCompanyUserPage = location.pathname.startsWith('/add-user/');
  const isProfileSettingPage = location.pathname.startsWith('/profile-setting');
  const isSubscriptionPage = location.pathname.startsWith('/subscription');
  const isArticleFormPage = [
    '/create-company-article',
    '/add-company-article/',
    '/edit-company-article/',
  ].some((p) => location.pathname.startsWith(p));
  const fullWidthBesideSidebar = isProfileSettingPage || (viewportWidth < COMPANY_FULL_WIDTH_BELOW && (isCompanyDetailsPage || isArticleFormPage || isEditCompanyPage || isCompanySettingPage || isCompanyFollowersPage || isAddCompanyUserPage || isSubscriptionPage));
  const isConstrainedWidthPage = constrainedWidthPaths.some((p) =>
    location.pathname.startsWith(p)
  ) && !fullWidthBesideSidebar;

  return (
    <React.Fragment>
      <div
        className={`${(activeSideBar == 'chat1' || activeSideBar == 'project1') ? "right_side_bar_main_div" : "right_side_bar"} right-bar${hideRightBar ? " right-bar--hidden" : ((isConstrainedWidthPage || (!inActivity && activeSideBar != 'articles' && activeSideBar != 'my-companies' && activeSideBar != 'profile')) && !fullWidthBesideSidebar) ? " right-bar--fill" : ""}`}
        // className={`right_side_bar`}
      >
        {activeSideBar == 'chat1' || activeSideBar == 'project1' ?
          <div className="search_bar_main_div">
            <SearchBar />
          </div>
          :
          <></>
        }

        {
            <div className={`user_chat_history_main_div right-bar__history${inActivity ? " right-bar__history--inactive" : ""}`}>
              {(props.rightTop === "project1" || roomsAliveRef.current) && !hideRoomList ?
                <div
                  className={`user_list_div_left room-list-enter${roomsExclusive ? (roomOpen ? " room-list-hidden" : " room-list-full") : ""} right-bar__rooms${props.rightTop === "project1" ? ((roomsExclusive || !isDesktop) ? ` right-bar__rooms--stacked${roomOpen ? " right-bar__rooms--collapsed" : ""}` : "") : " right-bar__rooms--off"}`}
                >
                  <MyProject changeBorder={_serColor} />
                </div>
                :
                <></>
              }
              {!inActivity && props.rightTop === "chat1" ?
                <div className={`user_list_div_left${isOpeningFromProfile ? " right-bar__chat-list--offscreen" : ""}`}>
                  <Chat />
                </div>
                :
                <></>
              }
              {!inActivity && (props.rightTop === "chat1" || props.inActivity) && props?.openChats?.length > 0 ?
                <div
                  className={`right-bar__chats${isDesktop ? " right-bar__chats--desktop" : ` right-bar__chats--overlay${!isOpeningFromProfile && isLatestMessagesSidebar ? " right-bar__chats--offset" : ""}`}${isOpeningFromProfile ? " right-bar__chats--profile" : ""}`}
                >
                  {/* <div style={{ flex: 1, backgroundColor: "#fff", display: "flex" }} className="user_chat_div_right"> */}
                  {props?.openChats?.map((chat, index) => (
                    <Conversation
                      chat={chat}
                      chat_key={chat?.key}
                      key={chat?.key}
                      openChatArr={props.openChats}
                      scrollToMessageId={chatScrollTarget?.chatGroupId?.toString() === chat?.id?.toString() ? chatScrollTarget.messageId : undefined}
                      scrollToMessagePage={chatScrollTarget?.chatGroupId?.toString() === chat?.id?.toString() ? chatScrollTarget.page_no : undefined}
                      onMessageHighlighted={chatScrollTarget?.chatGroupId?.toString() === chat?.id?.toString() ? () => { setChatScrollTarget(null); } : undefined}
                    />
                  ))}
                </div>
                :
                <></>}
              {!inActivity && (props.rightTop === "project1") ? (
                <div
                  className={`chanel_group_list_chat_main_div room-detail-enter right-bar__detail${roomsExclusive
                    ? ` right-bar__detail--exclusive${roomOpen ? "" : " right-bar__detail--closed"}`
                    : isDesktop
                    ? ` right-bar__detail--desktop${hideRoomList ? " right-bar__detail--pinned" : ""}`
                    : ` right-bar__detail--overlay${roomOpen ? "" : " right-bar__detail--closed"}`}`}
                >
                  {oversightRoom && !hasOpenProjects ? (
                    <OversightRoomDetail room={oversightRoom} />
                  ) : null}
                  {props?.openProjects?.map((project, index) => {
                    let tempIndex = index + 1;
                    return (
                      <ProjectDetailSection
                        idx={index}
                        id={project.id}
                        addUserAction={{
                          openAddProjectWindow: project?.openAddProjectWindow,
                          id: project.id,
                        }}
                        project_key={project.key}
                        key={project.key || project.id}
                        project={project}
                        lastIndex={props.openProjects?.length === tempIndex && index}
                        isPinnedShortcut={hideRoomList}
                      />
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
        }
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const {
    projects,
    openProjects,
    openBottomProjects,
    toggleWorkArea,
    rightTop,
    rightBottom,
    openChats,
    openBottomChats,
    groups,
    isOpenByOwner,
    unSeenAllCount,
    groupChats
  } = state;
  return {
    groups: groups,
    projects: projects,
    openProjects: openProjects,
    openBottomProjects: openBottomProjects,
    workArea: toggleWorkArea,
    rightTop: rightTop,
    rightBottom: rightBottom,
    openChats: openChats,
    openBottomChats: openBottomChats,
    isOpenByOwner: isOpenByOwner,
    unSeenAllCount: unSeenAllCount,
    groupChats: groupChats
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateProjects: (projects) =>
      dispatch({ type: PROJECTS, projects: projects }),
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateToggleWorkArea: (value) =>
      dispatch({ type: TOGGLE_WORK_AREA, toggleWorkArea: value }),
    updateRightTop: (value) => dispatch({ type: RIGHT_TOP, rightTop: value }),
    updateRightBottom: (value) =>
      dispatch({ type: RIGHT_BOTTOM, rightBottom: value }),
    updateOpenChats: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateOpenBottomChats: (chats) =>
      dispatch({ type: OPEN_BOTTOM_CHATS, openBottomChats: chats }),
    updateOpenProjectsList: (projects) =>
      dispatch({ type: OPEN_PROJECTS, openProjects: projects }),
    updateBottomOpenProjects: (projects) =>
      dispatch({ type: OPEN_BOTTOM_PROJECTS, openBottomProjects: projects }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
    updateGroupChats: (chats) => dispatch({ type: GROUP_CHATS, groupChats: chats }),
    updateProjectAction: (value) =>
      dispatch({
        type: UPDATE_PROJECT_ACTION_FIRE,
        updateProjectActionFire: value,
      }),
    toggleChat: () => dispatch({ type: TOGGLE_CHAT }),
    toggleProject: () => dispatch({ type: TOGGLE_PROJECT }),
  };
};

export default pure(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(RightBar))
);
